import { initMonitoring } from '@sky-distribution/gp-onboarding-monitoring';
import { XRouter } from '@sky-distribution/gp-onboarding-shared-components';
import { createRoot } from 'react-dom/client';
import { name, version } from '../package.json';
import { Bootstrap } from './bootstrap';
import { getProductDetails, loadProductConfiguration } from './config';

const { basePath, productId } = getProductDetails(window.location.pathname);
const config = loadProductConfiguration(productId);

initMonitoring({
  projectName: name,
  projectVersion: version,
  tracesSampleRate: 0.1,
});

(async () => {
  const container = document.getElementById('root')!;

  createRoot(container)
    .render(
      <XRouter basename={basePath}>
        <Bootstrap productId={productId} config={await config} />
      </XRouter>,
    );
})();
